// removed by extract-text-webpack-plugin
module.exports = {"Card":"_2bm6uftgil4ThitRD6EOX4","Body":"_1MdAXcF6DP0QcJ8IAWyFkK","Footer":"tLI1HBvjR5QzL6bWwfCIU","Title":"XPxNPYINoK7ksUjMiyqrV","Group":"dwhzy3ZihCfH5zbEClsMu","Row":"hd34R_L1jispF3a1ra3X8","Column":"_3_ke1248RfzsoTYD69Ce0B","CheckboxWrap":"_3cEjBUao-1W0NHPJsFr8WH","CustomCheckbox":"_1vUyD9X6yRDS1GUDExrXZj","InputIcon":"e-qJx_rVSGfF72KmnZGCy"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/TransactionsFilters/styles.module.css
// module id = 584
// module chunks = 0